var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlusSolidCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 631.28 631.28",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.64,0C141.32,0,0,141.32,0,315.64S141.32,631.28,315.64,631.28,631.28,490,631.28,315.64,490,0,315.64,0Zm192,363.64h-144v144a32,32,0,0,1-32,32h-32a32,32,0,0,1-32-32v-144h-144a32,32,0,0,1-32-32v-32a32,32,0,0,1,32-32h144v-144a32,32,0,0,1,32-32h32a32,32,0,0,1,32,32v144h144a32,32,0,0,1,32,32v32A32,32,0,0,1,507.64,363.64Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusSolidCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-solid-circle.dff5264f.svg";
export { ForwardRef as ReactComponent };